import React from 'react';
import { Row, Col, Form, Spin } from 'antd';
import LabelWithRequired from '../Label/LabelWithRequired';
import SelectCommon from '../Select/SelectCommon';
import { InputCommon } from '../Input/InputCommon';
import { FormInputProductrops } from 'types';
import {
  currencyRules,
  maxRules,
  minRules,
  costPriceRules,
  salePriceRules,
  currencyOnQuantityRules,
} from 'utils/formRules';
import { getFieldRules } from 'utils/getFieldRules';

const fieldRules = {
  min: minRules,
  max: maxRules,
  costPrice: costPriceRules,
  salePrice: salePriceRules,
  currency: currencyRules,
  currencyOnQuantity: currencyOnQuantityRules,
} as const;

const FormManagerProductCommon: React.FC<FormInputProductrops> = ({ form, fields, isDisabled = false }) => {
  return (
    <Form form={form} layout='vertical'>
      <Row gutter={24}>
        {fields.map((field, index) => (
          <Col span={6} key={index}>
            <Form.Item
              label={<LabelWithRequired label={field.label} />}
              name={field.name}
              required={false}
              rules={getFieldRules(field.name, form, fieldRules)}
              initialValue={field.defaultValue}
              className='mb-0'
            >
              {field.type === 'select' ? (
                <SelectCommon
                  disabled={isDisabled}
                  statusSelect={!isDisabled ? 'default' : 'disabled'}
                  placeholderSelect={field.placeholder}
                  defaultValue={field.defaultValue}
                  selectType={field.type}
                  options={field.options!}
                  loading={field.loading}
                  notFoundContent={field.loading ? <Spin size='small' /> : 'No results found'}
                />
              ) : (
                <InputCommon
                  disabled={isDisabled}
                  type={field.type}
                  placeholder={field.placeholder}
                  onChange={field.onChange}
                  addonAfterNode={field.addonAfterNode}
                  className='!px-3'
                />
              )}
            </Form.Item>
          </Col>
        ))}
      </Row>
    </Form>
  );
};

export default FormManagerProductCommon;
